<div 
  class="loader"
  [ngStyle]="style"
>
  <div class="loader__icon">
    <img
      src="/assets/images/loading-line.svg"
      class="loader__progress"
      alt="loading"
    />

    <img
      src="/assets/images/herb.svg"
      alt="Herb"
    />
  </div>
</div>